import { Exclude } from 'class-transformer'
import { Guid } from 'guid-typescript'

import { ConditionType } from '../types'

export default class BaseCondition {
  type!: ConditionType
  invert!: boolean

  @Exclude()
  guid: string = Guid.create().toString()
}
